import React, { useEffect } from 'react';
import Head from 'next/head';

import { observer } from 'mobx-react';

import Header from './header';
import Footer from './footer';

import useLayoutInit from './use-layout-init';

const PageBase = observer((props: any) => {
  const {
    children,
    hasHeader = true,
    hasFooter = true,
    currentPage = '',
  } = props;

  useLayoutInit();

  return (
    <>
      <Head>
        <title>么么直播</title>
        <meta
          content="么么直播,么么秀场,美女主播,美女视频,视频直播,美女秀场"
          name="keywords"
        />
        <meta
          content="么么直播，一个与真人美女主播在线视频聊天的交友社区，支持百万人同时在线视频聊天交友、K歌互动。"
          name="description"
        />
      </Head>
      {hasHeader && <Header currentPage={currentPage} />}
      {children}
      {hasFooter && <Footer />}
    </>
  );
});

export default PageBase;
